import React from 'react';
import PropTypes from 'prop-types';

function ElevationIcon(props) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 18.5L5.5 20L12 13.5L18.5 20L20 18.5L12 10.5L4 18.5ZM4 4V6H20V4H4Z" fill={props.color || 'black'} />
    </svg>
  );
}

ElevationIcon.propTypes = {
  color: PropTypes.string
};

export default ElevationIcon;